import ShopHeader from "../components/shared/shopheader";
import ShopHeaderMobile from "../components/shared/shopheaderMobile.vue";
import checkbox from "./../components/shared/checkbox.vue";
import modal from "./../components/shared/Modal";
import ReservationInfo from "../components/reservation/ReservationInfo.vue";
import GuestInfo from "../components/reservation/GuestInfo.vue";
import Thankyou from "../components/reservation/ReservationThankyou.vue";
import CardComponent from "../components/reservation/CardComponent.vue";
import poweredby from "../components/shared/Poweredby.vue";
import poweredbyWhite from "../components/shared/Poweredby-withe.vue";
import { DetectMobile } from "../helpers/ui/detectmobile";
import { geo } from "../helpers/geo/geo";
import { getColorConfig } from "../helpers/ui/colorhelper.js";
import {
  getCompanyProfile,
  setBookingInfo,
  getAvailableTimes,
  getStoreStripeStatus,
} from "../services/reservationService";
import { DateTime } from "luxon";
import { wcconfig } from "../../wcConfig.js";
import { setDatePickerMargin } from "../helpers/ui/uiHelper";
import { venueHelper } from "../helpers/ui/venueHelper";
import { dateHelper } from "../helpers/dateHelper/dateHelper";
import { handleBooking } from "../api/stripe.js";

export default {
  components: {
    poweredbyWhite,
    ShopHeaderMobile,
    ShopHeader,
    checkbox,
    ReservationInfo,
    GuestInfo,
    Thankyou,
    CardComponent,
    poweredby,
    modal,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    disableWidget: {
      type: Boolean,
      default: false,
    },
    configurationInfo: {
      type: Object,
      default: function() {
        return {
          showDeposit: false,
          minimumDepositPerGuest: 0,
          currency: "$",
          wizardIndex: 0,
          singlePage: false,
          showVenue: true,
          showBookingType: true,
          defaultDate: "",
          defaultTime: "",
          defaultGuest: "",
          theme: "",
          Styles: {},
        };
      },
    },
    reservationItems: {
      type: Object,
      default: function() {
        return {
          venues: [],
          bookingTypes: [],
          numberOfGuests: [],
          dates: [],
          times: [],
          stores: [],
          availableTimes: [],
          availableSeats: [],
          aroundTimes: [],
        };
      },
    },
    embededMode: false,
    mobileMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      availableDays: [],
      pos: null,
      showIndicator: false,
      msg: "",
      url: "",
      errorMessage: "",
      GuestCount: 0,
      disabledDates: {},
      lastUserSelection: null,
      validationStatus: {
        reservationInfoValidated: false,
        guestInfoValidated: false,
        firstNameValidated: true,
        lastNameValidated: true,
        phoneValidated: true,
        emailValidated: true,
      },
      errorCustomMessages: {
        venueError: "Failed to update (Venue)",
        bookingTypeError: "Failed to update (Booking Type)",
        getTimesError: "Failed to update (Time)",
        bookingError: "Failed to update (Booking)",
        unknownError: "Failed to update (Unknown)",
        bookedOut: "No sessions available on this date",
      },
      validationErrors: {
        dateError: "Date cannot be in the past",
        phoneError: "Phone number is invalid",
        firstNameError: "First name is invalid",
        lastNameError: "Last name is invalid",
        emailError: "Email address is invalid",
      },

      reservationInfo: {
        venue: 0,
        bookingType: "",
        numberOfGuests: 1,
        date: "",
        time: "",
        exactTime: "",
        venueInfo: {},
        HqInfo: {},
      },

      guestInfo: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        countryIso: "AU",
        cardNumber: "",
        yearMonth: "",
        cvv: "",
        note: "",
      },
      bookingInfo: {
        ArrivalStatus: 0,
        BookingDateTime: "",
        BookingEndingDateTime: "",
        BookingName: "",
        Category: "",
        CompanyName: "",
        Company_ID: "",
        CustomerSpend: 0,
        Deposit: 0,
        Email: "",
      },
      cardInfo: {
        Amount: 0,
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        ForceUseSandboxPayment: true,
      },
      TermsAndConditions: "",
      showModal: false,
      stripeStatus: true,
      timeslotsErrorMessage: null,
    };
  },
  created() {
    this.pos = geo.getLocation();
    getStoreStripeStatus(parseInt(this.storeid))
      .then((result) => {
        this.stripeStatus = result.data.Success;
      })
      .catch((error) => {
        that.showError("venue", error);
      });
  },
  mounted() {
    this.url = wcconfig.assets.ajaxIndicator;
    this.getVenues();
    setDatePickerMargin();
  },
  watch: {
    errorMessage(newVal) {
      if (newVal == this.errorCustomMessages.bookedOut) {
        this.timeslotsErrorMessage = newVal;
      } else {
        this.timeslotsErrorMessage = null;
      }
    }
  },
  methods: {
    venueChanged(storeId) {
      this.reservationItems.availableTimes = new Array();
      this.reservationItems.availableSeats = new Array();
      this.setVenueInfo(storeId);
      this.setVenueNumberOfGuests();
      this.setVenueBookingTypes();
      this.configDatePicker();
      this.getTimes(
        storeId,
        this.reservationInfo.date,
        this.reservationInfo.numberOfGuests
      );

      this.configurationInfo.Styles = getColorConfig(
        this.reservationInfo.venueInfo
      );
    },
    setVenueInfo(storeId) {
      let that = this;
      if (that.reservationItems) {
        that.reservationItems.venues.forEach((item) => {
          if (item.Company_ID == storeId) {
            that.reservationInfo.venueInfo = item;
          }
        });
      }
    },
    setDefaultValues() {
      this.configurationInfo.wizardIndex = 0;
      if (this.configurationInfo.defaultGuest != "") {
        this.reservationInfo.numberOfGuests = this.reservationItems.numberOfGuests[
          this.configurationInfo.defaultGuest
        ];
        this.configurationInfo.defaultGuest = "";
      }
      if (this.configurationInfo.defaultDate != "") {
        this.reservationInfo.date = this.configurationInfo.defaultDate;

        this.configurationInfo.defaultDate = "";
      }

      this.getTimes(
        this.reservationInfo.venue ? this.reservationInfo.venue : this.storeid,
        this.reservationInfo.date,
        this.reservationInfo.numberOfGuests
      );
    },
    configDatePicker() {
      this.reservationInfo.date = dateHelper.getDefaultDate();
      this.disabledDates = dateHelper.getDisableDates();
    },
    dateChanged() {
      this.reservationItems.availableTimes = new Array();
      this.reservationItems.availableSeats = new Array();
      this.getTimes(
        this.reservationInfo.venue,
        this.reservationInfo.date,
        this.reservationInfo.numberOfGuests
      );
      this.validate();
    },
    getVenues() {
      let that = this;
      that.startLoading();
      getCompanyProfile(that.storeid)
        .then((companyProfile) => {
          const result = venueHelper.populateVenues(companyProfile.data);
          that.reservationInfo.venueInfo = result.venueInfo;
          that.reservationInfo.HqInfo = result.HqInfo;

          that.reservationItems.venues = result.venues;
          venueHelper.getVenuesByOrder(that.reservationItems.venues);
          that.loadDefaultVenue();
        })
        .catch((error) => {
          that.showError("venue", error);
        });
    },
    loadDefaultVenue() {
      let that = this;
      if (that.reservationItems.venues.length >= 1) {
        that.reservationInfo.venue = that.reservationItems.venues[0].Company_ID;
        that.venueChanged(
          that.reservationInfo.venue ? that.reservationInfo.venue : that.storeid
        );
      }
    },
    setVenueBookingTypes() {
      let that = this;
      that.startLoading();
      that.reservationItems.bookingTypes = venueHelper.populateBookingTypes(
        that.reservationInfo.venueInfo
      );
      if (that.reservationItems.bookingTypes)
        that.reservationInfo.bookingType =
          that.reservationItems.bookingTypes[0];
      that.endLoading();
    },
    setVenueNumberOfGuests() {
      let that = this;
      that.startLoading();
      let result = venueHelper.getVenueNumberOfGuestInfo(
        that.reservationInfo.venueInfo
      );
      that.reservationItems.numberOfGuests = result.numberOfGuestsList;
      that.reservationInfo.numberOfGuests = result.minGuest;
      that.endLoading();
    },
    goNextStep() {
      this.configurationInfo.wizardIndex++;
      this.validationStatus.guestInfoValidated = false;
      this.validate();
    },
    goPreStep() {
      if (this.configurationInfo.wizardIndex > 0) {
        this.configurationInfo.wizardIndex--;
        this.validate();
      } else {
        if (this.$parent) this.$parent.closeModal();
      }
    },
    async getTimes(
      storeId,
      date,
      numberOfGuest,
      recursiveCount = 0,
      searchNextAvailableSessions = false
    ) {
      if (date == "") {
        return;
      }
      var preTime = this.reservationInfo.time;
      var dateTime = DateTime.fromJSDate(new Date(date));
      var now = DateTime.local();
      if (dateTime.toISODate() < now.toISODate()) {
        date = "";
        this.errorMessage = this.validationErrors.dateError;
        return;
      } else {
        this.errorMessage = "";
      }

      this.reservationInfo.time = "";
      let that = this;

      that.startLoading();
      that.reservationItems.times = new Array();
      var shortDateFormat = dateHelper.getShortDateFormat(date);
      if (that.reservationItems.availableTimes.length == 0) {
        var result = await getAvailableTimes(storeId, shortDateFormat);
        if (result.data.AvailableSessions.length > 0) {
          that.reservationItems.availableTimes = new Array();
          that.reservationItems.availableSeats = new Array();
          result.data.AvailableSessions.forEach((item) => {
            that.reservationItems.availableTimes.push(item.startTime);
            that.reservationItems.availableSeats.push(item.available);
          });
          var populateResult = that.populateTimes(
            that.reservationItems.availableTimes,
            that.reservationItems.availableSeats,
            numberOfGuest,
            preTime
          );
          if (populateResult) {
            that.reservationInfo.date = date;
            that.endLoading();
            that.validate();
          } else {
            that.handleBookedOut(
              storeId,
              date,
              numberOfGuest,
              recursiveCount,
              searchNextAvailableSessions
            );
          }
        } else {
          that.handleBookedOut(
            storeId,
            date,
            numberOfGuest,
            recursiveCount,
            searchNextAvailableSessions
          );
        }
      } else {
        that.reservationInfo.date = date;
        var result = await getAvailableTimes(storeId, shortDateFormat);
        if (result.data.AvailableSessions.length > 0) {
          that.reservationItems.availableTimes = new Array();
          that.reservationItems.availableSeats = new Array();
          result.data.AvailableSessions.forEach((item) => {
            that.reservationItems.availableTimes.push(item.startTime);
            that.reservationItems.availableSeats.push(item.available);
          });
        }
        var populateResult = that.populateTimes(
          that.reservationItems.availableTimes,
          that.reservationItems.availableSeats,
          numberOfGuest,
          preTime
        );
        if (populateResult) {
          that.reservationInfo.date = date;
          that.endLoading();
          that.validate();
        } else {
          that.handleBookedOut(
            storeId,
            date,
            numberOfGuest,
            recursiveCount,
            searchNextAvailableSessions
          );
        }
        that.endLoading();
        that.validate();
      }
    },
    handleBookedOut(
      storeId,
      date,
      numberOfGuest,
      recursiveCount,
      searchNextAvailableSessions
    ) {
      this.lastUserSelection = { storeId, date, numberOfGuest };
      if (searchNextAvailableSessions && recursiveCount <= 3) {
        this.errorMessage = "";
        this.getTimes(
          storeId,
          dateHelper.addDate(date, 1),
          numberOfGuest,
          recursiveCount + 1,
          searchNextAvailableSessions
        );
      } else {
        this.$emit("change-venu", this.reservationInfo, this.reservationItems);
        this.errorMessage = this.errorCustomMessages.bookedOut;
        this.endLoading();
        this.validate();
      }
    },
    searchForNextSessions() {
      this.reservationItems.availableTimes = new Array();
      this.reservationItems.availableSeats = new Array();
      let that = this;
      this.getTimes(
        that.lastUserSelection.storeId,
        that.lastUserSelection.date,
        that.lastUserSelection.numberOfGuest,
        0,
        true
      );
      this.validate();
    },
    startLoading() {
      this.showIndicator = true;
      this.errorMessage = "";
    },
    endLoading() {
      this.showIndicator = false;
    },
    validate() {
      this.validationStatus = venueHelper.validateBookingInfo(
        this.configurationInfo,
        this.reservationInfo,
        this.guestInfo
      );
    },
    showError(category) {
      this.showIndicator = false;
      switch (category) {
        case "venue":
          this.errorMessage = this.errorCustomMessages.venueError;
          break;
        case "booking-type":
          this.errorMessage = this.errorCustomMessages.bookingTypeError;
          break;
        case "get-times":
          this.errorMessage = this.errorCustomMessages.getTimesError;
          break;
        case "booking":
          this.errorMessage = this.errorCustomMessages.bookingError;
          break;
        default:
          this.errorMessage = this.errorCustomMessages.unknownError;
          break;
      }
    },

    populateTimes(
      availableTimes,
      availableSeats,
      numberOfGuest,
      preTime,
      daydate = null
    ) {
      let that = this;
      if (daydate != null) {
        that.reservationItems.times = venueHelper.populateTimes(
          availableTimes,
          availableSeats,
          numberOfGuest,
          daydate
        );
      } else {
        that.reservationItems.times = venueHelper.populateTimes(
          availableTimes,
          availableSeats,
          numberOfGuest,
          that.reservationInfo
        );
      }

      if (that.reservationItems.times.length == 0) {
        that.errorMessage = that.errorCustomMessages.bookedOut;
        return false;
      } else {
        let result = venueHelper.pickDefaultTime(
          that.reservationItems.times,
          preTime,
          that.configurationInfo.defaultTime
        );
        that.reservationInfo.time = result.pickedTime;
        that.configurationInfo.defaultTime = result.defaultTime;
        if (that.reservationInfo.time != "") {
          that.populateAroundTimes(that.reservationInfo.time);
        }

        return true;
      }
    },
    populateAroundTimes() {
      let that = this;
      const aroundTimesResult = venueHelper.populateAroundTimes(
        that.reservationInfo.time,
        that.reservationItems.times
      );
      that.reservationInfo.exactTime = aroundTimesResult.exactTime;
      that.reservationItems.aroundTimes = aroundTimesResult.aroundTimes;
      that.validate();
      that.$emit("change-venu", that.reservationInfo, that.reservationItems);
    },
    async book() {
      if (this.showIndicator !== true) {
        this.errorMessage = "";
        let that = this;
        that.startLoading();

        try {
          this.bookingInfo = venueHelper.createBookingInfoObject(
            this.reservationInfo,
            this.guestInfo,
            this.reservationItems,
            this.configurationInfo,
            this.cardInfo
          );
          var cms = [];
          if (this.$refs.cartComponent) {
            let card = this.$refs.cartComponent.validate();
            cms.push(card);
          }
          cms.push(this.$refs.guestInfo.validate());
          cms.push(this.$validator.validateAll());
          const stripe = this.$stripe;
          const cardElement = this.$refs.guestInfo && this.$refs.guestInfo.$refs.cardInfo ? this.$refs.guestInfo.getCardElement : "";
          Promise.all(cms).then(async (values) => {
            if (values.every(async (v) => v)) {
              try {
                const result = await handleBooking(
                  this.reservationInfo,
                  this.bookingInfo.Deposit,
                  this.storeid,
                  this.bookingInfo,
                  this.bookingInfo.Uuid,
                  'aud',
                  stripe,
                  cardElement
                );
                if (!result.success) {
                  this.errorMessage = result.error;
                  that.endLoading();
                  return;
                }
                this.configurationInfo.wizardIndex++;
                that.endLoading();
              } catch(error) {
                that.showError("booking", error);
              }

              // .then(
              //   (result) => {
              //     if (!result.data.Success) {
              //       this.errorMessage = result.data.Status.Message;
              //       that.endLoading();
              //       return;
              //     } else {
              //       this.configurationInfo.wizardIndex++;
              //       that.endLoading();
              //     }
              //   },
              //   (resean) => {
              //     that.showError("booking", resean);
              //   }
              // );
            } else {
              that.endLoading();
              that.$el.querySelector("[aria-invalid=true]").focus();
            }
          });
        } catch (e) {
          that.endLoading();
          that.showError("booking", e);
        }
      }
    },
    closeModal2() {
      this.showModal = false;
    },
    terms() {
      if (this.reservationInfo.venueInfo.TermsAndConditionsTemplate)
        this.TermsAndConditions = this.reservationInfo.venueInfo.TermsAndConditionsTemplate;
      else
        this.TermsAndConditions =
          "By placing a reservation request, you acknowledge that your contact details entered above (name, phone number, and email address) will be recorded and accessible by " +
          this.reservationInfo.venueInfo.Name +
          ", who will use these details to contact you on the status of your reservation. You also accept that by placing a reservation request online, you are only expressing your interest in a reservation. No reservation is confirmed until a reservation confirmation email has been sent to your email address.";
      this.showModal = true;
    },
    isMobile() {
      return DetectMobile.methods.isMobile();
    },
    getArrowColor() {
      if (this.embededMode) {
        return {
          color: "#fff",
        };
      } else {
        if (this.isMobile())
          return {
            color: "white",
          };
        else
          return {
            color: "#fff",
          };
      }
    },
    getHeaderStyles() {
      if (this.embededMode) {
        if (this.disableWidget) {
          return {
            color: "black",
            display: "flex",
            position: "absolute",
            top: "5px",
          };
        } else {
          return {
            color: "#fff",
            display: "flex",
            position: "absolute",
            top: "-30px",
          };
        }
      } else {
        return {
          color: "#fff",
          "padding-bottom": "20px",
          display: "flex",
          position: "absolute",
          top: "5px",
        };
      }
    },
    hasPayment() {
      return venueHelper.hasPayment(this.reservationInfo);
    },
    paymentValue() {
      return venueHelper.paymentValue(this.reservationInfo);
    },
    isDepositPerGeust() {
      return venueHelper.isDepositPerGeust(this.reservationInfo);
    },
  },
};
